import { useRouter } from 'next/router';

/**
 *
 * @param pathname          pathname returned from useRouter()
 * @param targetPathSuffix  pathname suffix, omitting root docs app path
 *                          e.g., for docs page '/docs/platform', is '/platform'
 * @returns boolean         if matches target docs page
 */
const isPathnameMatch = ({
  pathname,
  targetPathSuffix,
}: {
  pathname: ReturnType<typeof useRouter>['pathname'];
  targetPathSuffix: string;
}) => {
  if (!targetPathSuffix.startsWith('/'))
    throw new Error(`targetPathSuffix "${targetPathSuffix}" should start with '/'`);
  return pathname === `${process.env.siteBasePath}${targetPathSuffix}`;
};

export default isPathnameMatch;
